// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!./login-new-theme.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAQElEQVR42qXKwQkAIAxDUUdxtO6/RBQkQZvSi8I/pL4BoGw/XPkh4XigPmsUgh0626AjRsgxHTkUThsG2T/sIlzdTsp52kSS1wAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: -apple-system, BlinkMacSystemFont, "Poppins", "Segoe UI", Roboto,
    Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 0.875rem;
  color: #1f2a68;
}

html,
body {
  height: 100%;
}

a,
a:hover {
  text-decoration: none;
}

.fw-700 {
  font-weight: 700;
}

.fw-600 {
  font-weight: 600;
}

.fw-500 {
  font-weight: 500;
}

.fw-400 {
  font-weight: 400;
}

.fw-300 {
  font-weight: 300;
}

.fw-200 {
  font-weight: 200;
}

.fw-100 {
  font-weight: 100;
}

.fs-70 {
  font-size: 70px;
}

.fs-60 {
  font-size: 60px;
}

.fs-56 {
  font-size: 56px;
}

.fs-50 {
  font-size: 50px;
}

.fs-40 {
  font-size: 40px;
}

.fs-36 {
  font-size: 36px;
}

.fs-34 {
  font-size: 34px;
}

.fs-32 {
  font-size: 32px;
}

.fs-30 {
  font-size: 30px;
}

.fs-28 {
  font-size: 28px;
}

.fs-26 {
  font-size: 26px;
}

.fs-24 {
  font-size: 24px;
}

.fs-22 {
  font-size: 22px;
}

.fs-20 {
  font-size: 20px;
}

.fs-18 {
  font-size: 18px;
}

.fs-16 {
  font-size: 16px !important;
}

.fs-15 {
  font-size: 15px;
}

.fs-14 {
  font-size: 14px;
}

.fs-13 {
  font-size: 13px;
}

.fs-12 {
  font-size: 12px;
}

.fs-11 {
  font-size: 11px;
}

.fs-10 {
  font-size: 10px;
}

.form-group {
  margin-bottom: 1rem;
}

.btn-primary {
  color: #fff;
  background-color: #377dff;
  border-color: #377dff;
}

.btn-primary:hover {
  color: #fff;
  background-color: #2f6ad9;
  border-color: #2c64cc;
}

.btn.btn-active-primary {
  color: #377dff;
  background-color: #f0f6ff;
}

.btn.btn-active-primary:hover:not(.btn-active) {
  color: #fff;
  border-color: #377dff;
  background-color: #377dff;
}

.text-primary,
a {
  color: #377dff !important;
}

a:hover:not(.btn:hover) {
  text-decoration: underline;
}

/* Login */

.login-main-bg {
  /* top: 0;
  width: 100%;
  bottom: 0;
  z-index: 999;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center; */
  /* background-image: url(hero-bg.svg);
  background-repeat: no-repeat;
  background-position: center; */
  /* background-size: cover; */
  padding: 30px 0;
  min-height: 100vh;
  background-color: #faf6ed;
  display: flex;
  align-items: center;
}

.form-info-card {
  border: 0;
  border-radius: 12px;
  padding: 35px 45px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  max-width: 440px;
  margin: auto;
}
.btn-orange,
.btn-orange:disabled {
  color: #fff;
  background-color: #ff7342;
  border-color: #ff7342;
}

.btn-orange:hover {
  color: #fff;
  background-color: #ff885e;
  border-color: #ff8155;
}

.form-control {
  font-size: 0.875rem;
  padding: 0.85rem 1rem;
  /* border-color: #d2ddec; */
  border-color: #e6eaed;
  /* border-radius: 8px; */
}

.form-control:focus {
  border-color: #377dff;
  box-shadow: none;
}

.form-control::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #b7c0cc;
  opacity: 1;
  /* Firefox */
}

.form-control:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #777;
}

.form-control::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #777;
}
.shopify-input-group .form-control.form-control-solid {
  background-color: #F3F6F9;
  border-color: #F3F6F9;
  transition: color 0.2s ease, background-color 0.2s ease;
}
.shopify-input-group .input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #1F2A68;
  text-align: center;
  white-space: nowrap;
  background-color: #e7eef5;
  border: 1px solid #d6e3ef;
  border-radius: 0.42rem;
}
.shopify-input-group .form-control-lg {
  min-height: calc(1.5em + 1.75rem + 2px);
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  border-radius: 0.42rem;
}
.shopify-input-group .form-control {
  display: block;
  width: 1%;
  padding: 0.5rem 1rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #1F2A68;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d6e3ef;
  appearance: none;
  border-radius: 0.42rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.btn {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  color: #1F2A68;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.5rem 1.5rem;
  font-size: 0.8125rem;
  border-radius: 0.42rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn.btn-outline-light {
  color: #1F2A68;
  background-color: #fff;
  border-color: #ccd8e7;
}

.btn.btn-outline-light:hover {
  color: #1F2A68;
  background-color: #e4ecf9;
  border-color: #e4ecf9;
}

.btn-primary {
  color: #fff;
  background-color: #377dff;
  border-color: #377dff;
}

.btn-primary:hover {
  color: #fff;
  background-color: #2f6ad9;
  border-color: #2c64cc;
}

.btn-close:focus {
  box-shadow: none;
}

.btn:focus,
.btn:active:focus {
  box-shadow: none;
  outline: none;
}

.login-btn {
  padding: 0.8rem 1rem;
  font-size: 1rem;
  font-weight: 500;
  /* border-radius: 8px; */
}

.google-btn {
  /* border: 1px solid #eee; */
  background-color: #f0f6ff;
  color: #377dff;
  text-transform: uppercase;
}

.google-btn:hover {
  background-color: #e0ecff;
  color: #377dff;
}
.google-btn:focus {
  background-color: #f0f6ff;
  color: #377dff;
}

.extra-login {
  width: 35%;
  text-align: center;
  border-bottom: 1px solid #e3ebf6;
  line-height: 0.1em;
  margin: 35px auto 30px;
  color: #95aac9;
  text-transform: uppercase;
}

.extra-login span {
  background: #fff;
  padding: 0 10px;
  font-size: 13px;
}
.or-divider {
  margin: 18px auto 16px;
}

.copyright {
  font-size: 12px;
  text-align: center;
}

.login-video .login-video-autoplay {
  /* object-fit: cover; */
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url(https://d2p078bqz5urf7.cloudfront.net/images/login/login-static-bg.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.open-new-tab-icon {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  /* margin: 0 3px 0 5px; */
  height: 8px;
  width: 8px;
}
.form-control.verification-code-digit {
  text-align: center;
}
@keyframes otp-shake {
  0%, 100% { transform: translateX(0); }
  20%       { transform: translateX(-6px); }
  40%       { transform: translateX(6px); }
  60%       { transform: translateX(-4px); }
  80%       { transform: translateX(4px); }
}
.otp-shake {
  animation: otp-shake 0.4s ease-in-out;
}
.user-verification-noty,
.user-verification-noty.error {
  top: 0;
  height: 50px;
  width: 100%;
  background: #ffc8b6;
  position: fixed;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-verification-noty .content {
  text-align: center;
  /* padding-top: 8px; */
  font-size: 13px;
  color: #ce2020;
}
.user-verification-noty.success {
  background: #4fbb68;
}
.user-verification-noty.success .content {
  color: #fff;
}

.hide {
  display: none !important;
}
.login-form-right {
  margin-left: auto;
  margin-right: 0;
}
.login-testimonial-sec.card {
  box-shadow: 0 0 0 0.05rem rgba(130, 8, 8, 0.06),
    0 0 1.25rem rgba(30, 34, 40, 0.04);
  border: 0;
  border-radius: 15px;
  max-width: 510px;
  margin: 100px 20px 0;
  background-color: #fffdf7;
  position: fixed;
}
.login-testimonial-sec::before {
  content: "";
  position: absolute;
  right: -60px;
  top: -60px;
  width: 100%;
  background-image: url(https://d2p078bqz5urf7.cloudfront.net/images/login/finger-down.svg);
  background-repeat: no-repeat;
  background-size: contain;
  height: 80px;
  background-position: right;
}
.login-testimonial-sec::after {
  content: "";
  position: absolute;
  left: -60px;
  bottom: -60px;
  width: 100%;
  background-image: url(https://d2p078bqz5urf7.cloudfront.net/images/login/finger-up.svg);
  background-repeat: no-repeat;
  background-size: contain;
  height: 80px;
  background-position: left;
}
.login-testimonial-sec .card-body {
  padding: 25px 20px;
}
.login-testimonial-sec .user-img {
  width: 4.5rem;
  height: 4.5rem;
}
.blockquote-content {
  font-weight: 300;
  margin-bottom: 1rem;
}
.login-testimonial-sec .info h5 {
  font-weight: 600;
  font-size: 1.1rem;
}
.login-testimonial-sec .info p {
  font-weight: 300;
}
.login-awards-sec {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 1rem;
}
.login-awards-sec span img {
  height: 90px;
}
.login-awards-sec .capterra-img img {
  height: 57px;
}

.modal .modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.75rem 0;
  border-bottom: 0 solid #e4e6ef;
  border-top-left-radius: 0.42rem;
  border-top-right-radius: 0.42rem;
}

.modal .modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal .modal-footer {
  padding: 1rem 1.75rem;
  background-color: #f7f7fb;
  border-top: 0;
}

.pwd-field-icon-underline{
  text-decoration: none!important;
}

.pwd-field-icon-underline svg{
  height:24px;
  width:24px;
  padding: 0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  fill: none;
  stroke: #afafaf;
  stroke-width: 3;
}
.pwd-field-icon-underline svg:hover{
  stroke: #989595;

}

.toggle-password::-ms-reveal {
  display: none;
}

@media (min-width:992px) and (max-width:1399px){
    .login-testimonial-sec.card {
        max-width: 30%;
        margin: 70px 0px 0;
    }
    .login-testimonial-sec .user-img {
        width: 3.5rem;
        height: 3.5rem;
    }
    .blockquote-content {
        font-size: 11px;
    }
    .login-testimonial-sec .info h5 {
        font-size: 14px;
    }
    .login-testimonial-sec .info p {
        font-size: 11px;
    }
}
@media (max-width: 991px) {
  .login-form-right {
    margin-right: auto;
  }
  .login-testimonial-sec.card,
  .login-awards-sec {
    display: none;
  }
}

@media (max-width: 767px) {
  .form-info-card {
    max-width: 100%;
    padding: 30px 20px;
    font-size: 0.8rem;
  }

  .logo-brand img {
    height: 26px;
  }

  .login-video {
    display: none;
  }

  .login-main-bg {
    padding: 16px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/login-new.css"],"names":[],"mappings":"AAAA;EACE;;qBAEmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,UAAU;;AAEV;EACE;;;;;;;wBAOsB;EACtB;;gCAE8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,uDAAuD;AACzD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,uCAAuC;EACvC,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,wEAAwE;AAC1E;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,qIAAqI;AACvI;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,6FAA6F;EAC7F,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,gDAAwM;EACxM,yBAAyB;EACzB,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW,wBAAwB,EAAE;EACrC,YAAY,2BAA2B,EAAE;EACzC,YAAY,0BAA0B,EAAE;EACxC,YAAY,2BAA2B,EAAE;EACzC,YAAY,0BAA0B,EAAE;AAC1C;AACA;EACE,qCAAqC;AACvC;AACA;;EAEE,MAAM;EACN,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE;sCACoC;EACpC,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,yFAAyF;EACzF,4BAA4B;EAC5B,wBAAwB;EACxB,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,uFAAuF;EACvF,4BAA4B;EAC5B,wBAAwB;EACxB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;;AAEjB;;AAEA;EACE,aAAa;AACf;;AAEA;IACI;QACI,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,cAAc;IAClB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;EACE;IACE,kBAAkB;EACpB;EACA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["body {\n  font-family: -apple-system, BlinkMacSystemFont, \"Poppins\", \"Segoe UI\", Roboto,\n    Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\",\n    \"Segoe UI Symbol\";\n  font-size: 0.875rem;\n  color: #1f2a68;\n}\n\nhtml,\nbody {\n  height: 100%;\n}\n\na,\na:hover {\n  text-decoration: none;\n}\n\n.fw-700 {\n  font-weight: 700;\n}\n\n.fw-600 {\n  font-weight: 600;\n}\n\n.fw-500 {\n  font-weight: 500;\n}\n\n.fw-400 {\n  font-weight: 400;\n}\n\n.fw-300 {\n  font-weight: 300;\n}\n\n.fw-200 {\n  font-weight: 200;\n}\n\n.fw-100 {\n  font-weight: 100;\n}\n\n.fs-70 {\n  font-size: 70px;\n}\n\n.fs-60 {\n  font-size: 60px;\n}\n\n.fs-56 {\n  font-size: 56px;\n}\n\n.fs-50 {\n  font-size: 50px;\n}\n\n.fs-40 {\n  font-size: 40px;\n}\n\n.fs-36 {\n  font-size: 36px;\n}\n\n.fs-34 {\n  font-size: 34px;\n}\n\n.fs-32 {\n  font-size: 32px;\n}\n\n.fs-30 {\n  font-size: 30px;\n}\n\n.fs-28 {\n  font-size: 28px;\n}\n\n.fs-26 {\n  font-size: 26px;\n}\n\n.fs-24 {\n  font-size: 24px;\n}\n\n.fs-22 {\n  font-size: 22px;\n}\n\n.fs-20 {\n  font-size: 20px;\n}\n\n.fs-18 {\n  font-size: 18px;\n}\n\n.fs-16 {\n  font-size: 16px !important;\n}\n\n.fs-15 {\n  font-size: 15px;\n}\n\n.fs-14 {\n  font-size: 14px;\n}\n\n.fs-13 {\n  font-size: 13px;\n}\n\n.fs-12 {\n  font-size: 12px;\n}\n\n.fs-11 {\n  font-size: 11px;\n}\n\n.fs-10 {\n  font-size: 10px;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #377dff;\n  border-color: #377dff;\n}\n\n.btn-primary:hover {\n  color: #fff;\n  background-color: #2f6ad9;\n  border-color: #2c64cc;\n}\n\n.btn.btn-active-primary {\n  color: #377dff;\n  background-color: #f0f6ff;\n}\n\n.btn.btn-active-primary:hover:not(.btn-active) {\n  color: #fff;\n  border-color: #377dff;\n  background-color: #377dff;\n}\n\n.text-primary,\na {\n  color: #377dff !important;\n}\n\na:hover:not(.btn:hover) {\n  text-decoration: underline;\n}\n\n/* Login */\n\n.login-main-bg {\n  /* top: 0;\n  width: 100%;\n  bottom: 0;\n  z-index: 999;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center; */\n  /* background-image: url(hero-bg.svg);\n  background-repeat: no-repeat;\n  background-position: center; */\n  /* background-size: cover; */\n  padding: 30px 0;\n  min-height: 100vh;\n  background-color: #faf6ed;\n  display: flex;\n  align-items: center;\n}\n\n.form-info-card {\n  border: 0;\n  border-radius: 12px;\n  padding: 35px 45px;\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n  max-width: 440px;\n  margin: auto;\n}\n.btn-orange,\n.btn-orange:disabled {\n  color: #fff;\n  background-color: #ff7342;\n  border-color: #ff7342;\n}\n\n.btn-orange:hover {\n  color: #fff;\n  background-color: #ff885e;\n  border-color: #ff8155;\n}\n\n.form-control {\n  font-size: 0.875rem;\n  padding: 0.85rem 1rem;\n  /* border-color: #d2ddec; */\n  border-color: #e6eaed;\n  /* border-radius: 8px; */\n}\n\n.form-control:focus {\n  border-color: #377dff;\n  box-shadow: none;\n}\n\n.form-control::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: #b7c0cc;\n  opacity: 1;\n  /* Firefox */\n}\n\n.form-control:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #777;\n}\n\n.form-control::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #777;\n}\n.shopify-input-group .form-control.form-control-solid {\n  background-color: #F3F6F9;\n  border-color: #F3F6F9;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n.shopify-input-group .input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #1F2A68;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #e7eef5;\n  border: 1px solid #d6e3ef;\n  border-radius: 0.42rem;\n}\n.shopify-input-group .form-control-lg {\n  min-height: calc(1.5em + 1.75rem + 2px);\n  padding: 0.875rem 1rem;\n  font-size: 0.875rem;\n  border-radius: 0.42rem;\n}\n.shopify-input-group .form-control {\n  display: block;\n  width: 1%;\n  padding: 0.5rem 1rem;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #1F2A68;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #d6e3ef;\n  appearance: none;\n  border-radius: 0.42rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #1F2A68;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.5rem 1.5rem;\n  font-size: 0.8125rem;\n  border-radius: 0.42rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.btn.btn-outline-light {\n  color: #1F2A68;\n  background-color: #fff;\n  border-color: #ccd8e7;\n}\n\n.btn.btn-outline-light:hover {\n  color: #1F2A68;\n  background-color: #e4ecf9;\n  border-color: #e4ecf9;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #377dff;\n  border-color: #377dff;\n}\n\n.btn-primary:hover {\n  color: #fff;\n  background-color: #2f6ad9;\n  border-color: #2c64cc;\n}\n\n.btn-close:focus {\n  box-shadow: none;\n}\n\n.btn:focus,\n.btn:active:focus {\n  box-shadow: none;\n  outline: none;\n}\n\n.login-btn {\n  padding: 0.8rem 1rem;\n  font-size: 1rem;\n  font-weight: 500;\n  /* border-radius: 8px; */\n}\n\n.google-btn {\n  /* border: 1px solid #eee; */\n  background-color: #f0f6ff;\n  color: #377dff;\n  text-transform: uppercase;\n}\n\n.google-btn:hover {\n  background-color: #e0ecff;\n  color: #377dff;\n}\n.google-btn:focus {\n  background-color: #f0f6ff;\n  color: #377dff;\n}\n\n.extra-login {\n  width: 35%;\n  text-align: center;\n  border-bottom: 1px solid #e3ebf6;\n  line-height: 0.1em;\n  margin: 35px auto 30px;\n  color: #95aac9;\n  text-transform: uppercase;\n}\n\n.extra-login span {\n  background: #fff;\n  padding: 0 10px;\n  font-size: 13px;\n}\n.or-divider {\n  margin: 18px auto 16px;\n}\n\n.copyright {\n  font-size: 12px;\n  text-align: center;\n}\n\n.login-video .login-video-autoplay {\n  /* object-fit: cover; */\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-image: url(https://d2p078bqz5urf7.cloudfront.net/images/login/login-static-bg.svg);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.open-new-tab-icon {\n  content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAQElEQVR42qXKwQkAIAxDUUdxtO6/RBQkQZvSi8I/pL4BoGw/XPkh4XigPmsUgh0626AjRsgxHTkUThsG2T/sIlzdTsp52kSS1wAAAABJRU5ErkJggg==);\n  /* margin: 0 3px 0 5px; */\n  height: 8px;\n  width: 8px;\n}\n.form-control.verification-code-digit {\n  text-align: center;\n}\n@keyframes otp-shake {\n  0%, 100% { transform: translateX(0); }\n  20%       { transform: translateX(-6px); }\n  40%       { transform: translateX(6px); }\n  60%       { transform: translateX(-4px); }\n  80%       { transform: translateX(4px); }\n}\n.otp-shake {\n  animation: otp-shake 0.4s ease-in-out;\n}\n.user-verification-noty,\n.user-verification-noty.error {\n  top: 0;\n  height: 50px;\n  width: 100%;\n  background: #ffc8b6;\n  position: fixed;\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.user-verification-noty .content {\n  text-align: center;\n  /* padding-top: 8px; */\n  font-size: 13px;\n  color: #ce2020;\n}\n.user-verification-noty.success {\n  background: #4fbb68;\n}\n.user-verification-noty.success .content {\n  color: #fff;\n}\n\n.hide {\n  display: none !important;\n}\n.login-form-right {\n  margin-left: auto;\n  margin-right: 0;\n}\n.login-testimonial-sec.card {\n  box-shadow: 0 0 0 0.05rem rgba(130, 8, 8, 0.06),\n    0 0 1.25rem rgba(30, 34, 40, 0.04);\n  border: 0;\n  border-radius: 15px;\n  max-width: 510px;\n  margin: 100px 20px 0;\n  background-color: #fffdf7;\n  position: fixed;\n}\n.login-testimonial-sec::before {\n  content: \"\";\n  position: absolute;\n  right: -60px;\n  top: -60px;\n  width: 100%;\n  background-image: url(https://d2p078bqz5urf7.cloudfront.net/images/login/finger-down.svg);\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 80px;\n  background-position: right;\n}\n.login-testimonial-sec::after {\n  content: \"\";\n  position: absolute;\n  left: -60px;\n  bottom: -60px;\n  width: 100%;\n  background-image: url(https://d2p078bqz5urf7.cloudfront.net/images/login/finger-up.svg);\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 80px;\n  background-position: left;\n}\n.login-testimonial-sec .card-body {\n  padding: 25px 20px;\n}\n.login-testimonial-sec .user-img {\n  width: 4.5rem;\n  height: 4.5rem;\n}\n.blockquote-content {\n  font-weight: 300;\n  margin-bottom: 1rem;\n}\n.login-testimonial-sec .info h5 {\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n.login-testimonial-sec .info p {\n  font-weight: 300;\n}\n.login-awards-sec {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  gap: 1rem;\n}\n.login-awards-sec span img {\n  height: 90px;\n}\n.login-awards-sec .capterra-img img {\n  height: 57px;\n}\n\n.modal .modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.75rem 0;\n  border-bottom: 0 solid #e4e6ef;\n  border-top-left-radius: 0.42rem;\n  border-top-right-radius: 0.42rem;\n}\n\n.modal .modal-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.modal .modal-footer {\n  padding: 1rem 1.75rem;\n  background-color: #f7f7fb;\n  border-top: 0;\n}\n\n.pwd-field-icon-underline{\n  text-decoration: none!important;\n}\n\n.pwd-field-icon-underline svg{\n  height:24px;\n  width:24px;\n  padding: 0;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  fill: none;\n  stroke: #afafaf;\n  stroke-width: 3;\n}\n.pwd-field-icon-underline svg:hover{\n  stroke: #989595;\n\n}\n\n.toggle-password::-ms-reveal {\n  display: none;\n}\n\n@media (min-width:992px) and (max-width:1399px){\n    .login-testimonial-sec.card {\n        max-width: 30%;\n        margin: 70px 0px 0;\n    }\n    .login-testimonial-sec .user-img {\n        width: 3.5rem;\n        height: 3.5rem;\n    }\n    .blockquote-content {\n        font-size: 11px;\n    }\n    .login-testimonial-sec .info h5 {\n        font-size: 14px;\n    }\n    .login-testimonial-sec .info p {\n        font-size: 11px;\n    }\n}\n@media (max-width: 991px) {\n  .login-form-right {\n    margin-right: auto;\n  }\n  .login-testimonial-sec.card,\n  .login-awards-sec {\n    display: none;\n  }\n}\n\n@media (max-width: 767px) {\n  .form-info-card {\n    max-width: 100%;\n    padding: 30px 20px;\n    font-size: 0.8rem;\n  }\n\n  .logo-brand img {\n    height: 26px;\n  }\n\n  .login-video {\n    display: none;\n  }\n\n  .login-main-bg {\n    padding: 16px 0;\n  }\n}\n\n@import './login-new-theme.css';\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
